import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { PermissionService } from 'src/app/services/permission.service';
declare const $: any;

@Component({
    selector: 'app-btn-action',
    templateUrl: './btn-action.component.html',
    styleUrls: ['./btn-action.component.css']
})
export class BtnActionComponent {
    constructor(private permissionService: PermissionService) { }

    ngOnInit(): void {
        this.initTooltips();
    }

    ngOnDestroy(): void {
        this.destroyTooltips();
    }

    private initTooltips(): void {
        // Destruir tooltips existentes antes de crear nuevos
        this.destroyTooltips();
        
        // Inicializar tooltips con un pequeño retraso para asegurar que el DOM esté listo
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover',
                delay: { show: 300, hide: 100 }
            });
        }, 50);
    }

    private destroyTooltips(): void {
        try {
            $('[data-toggle="tooltip"]').tooltip('dispose');
        } catch (e) {
            // Ignorar errores si no hay tooltips inicializados
        }
    }

    public cellValue: any = { data: {} };
    dataUser: any = {}

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        // assign params defensively
        this.cellValue = params || { data: {} };
        // guard against missing parent or dataUser
        this.dataUser = (this.cellValue as any)?.parent?.dataUser || {};

    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.cellValue = params || { data: {} };
        
        // Reiniciar tooltips después de la actualización
        setTimeout(() => {
            this.initTooltips();
        }, 50);
        
        return true;
    }

    deleteEvent() {
        const id = this.cellValue?.data?.id;
        if (!this.cellValue?.parent || !id) { return; }
        this.cellValue.parent.cancelOrder(id)
    }

    dowloandService() {
        const id = this.cellValue?.data?.id;
        if (!this.cellValue?.parent || !id) { return; }
        this.cellValue.parent.dowloandService(id)
    }

    logEvent() {
        const logs = this.cellValue?.data?.logs;
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.logsService(logs)
    }
    updateObservation() {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.updateObservation(this.cellValue.data)
    }
    openModalUnit(id: any) {
        const unitId = this.cellValue?.data?.unit_id;
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.openModalChangedUnit(id, unitId)
    }

    addNota() {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.addNota(this.cellValue.data)
    }
    canDo(moduleKey: string, actionName: string): boolean {
        return this.permissionService.canDo(moduleKey, actionName);
    }
}
